import React from 'react';
import { Box, Skeleton } from '@mui/material';
import planGridSx from 'common/theme/overview-profile/planGridSx';

const TILE_COUNT = 5;

function ClientPlanSkeleton() {
  return (
    <Box sx={planGridSx}>
      {Array.from({ length: TILE_COUNT }, (_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={58}
          sx={{ borderRadius: '12px' }}
        />
      ))}
    </Box>
  );
}

export default ClientPlanSkeleton;
